var description = 'oz5nys1';
var root = 'oz5nys0';

export { description, root };
//# sourceMappingURL=switch.css.js.map
